import { render, staticRenderFns } from "./PortfolioPage.vue?vue&type=template&id=5b191fbe&scoped=true&"
import script from "./PortfolioPage.vue?vue&type=script&lang=js&"
export * from "./PortfolioPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b191fbe",
  null
  
)

export default component.exports